import FormSectionTitle from '../../../elements/FormSectionTitle'
import { defaultFormItemLayout, rules } from '../../../modules/FormItems'
import React from 'react'
import { compose } from 'recompose'
import { Button, Col, DatePicker, Divider, Form, Input, Row } from 'antd'
import StatusSelect from '../../../elements/Select/Supplier/StatusSelect'
import CountrySelect from '../../../elements/Select/Country'
import { dateVal, strVal } from '../../../modules/Utils'

function SupplierDetailsForm(props) {
  const { submitting, supplier, update } = props
  const { getFieldDecorator } = props.form
  return (
    <Form>
      <FormSectionTitle title={'Details'} />
      <Col span={12}>
        <Form.Item {...defaultFormItemLayout} label="Status">
          {getFieldDecorator('status', {
            initialValue: strVal(supplier, 'status'),
            rules: rules.input,
          })(<StatusSelect />)}
        </Form.Item>
      </Col>

      <Col span={12}>
        <Form.Item {...defaultFormItemLayout} label="Location">
          {getFieldDecorator('location', {
            initialValue: strVal(supplier, 'location'),
          })(<CountrySelect />)}
        </Form.Item>
      </Col>

      <Col span={12}>
        <Form.Item {...defaultFormItemLayout} label="Registration Date">
          <DatePicker
            disabled
            style={{ width: '100%' }}
            placeholder="Registration Date"
            value={dateVal(supplier, 'date.registration')}
          />
        </Form.Item>
      </Col>

      <Col span={12}>
        <Form.Item {...defaultFormItemLayout} label="Tax Registration">
          {getFieldDecorator('taxRegistration', {
            initialValue: strVal(supplier, 'taxRegistration'),
          })(<Input style={{ width: '100%' }} placeholder="Tax Registration" />)}
        </Form.Item>
      </Col>

      <Button loading={submitting} type="primary" onClick={update} style={{ marginTop: 20 }}>
        Update
      </Button>
    </Form>
  )
}

export default compose(Form.create())(SupplierDetailsForm)
